<script>
import firebase from "firebase";
import store from '../store';
// Vue boilerplate is export default 
export default {
    // name is for the router. has to match router
    name: "ms_skills",
    data() {
        // initalizing all component wide variables
        // Anytime one is changed, the whole component
        // is rerendered. 
        return {
            doneLoading: false,
            // showSubcategories: false,
            showAreas: false,
            showEmployees: false,
            // category: "",
            // subcategory: "",
            // area: "",
            // subcategories: [],
            //bottom two hold data
            areas: [],
            employees: [],
            modalActive: false,
            contactName: "",
            // subcategoryContext: null,
            // xContext is the area or cat that is clicked
            areaContext: null,
            categoryContext: null,
            showModal: false,
            addDesig: false,
            areaModal: false,
            userModal: false,
            currentUser: null,
            currentEmail: null,
            selectedEmployeeName:"",
            selectedEmployeeEmail:"",
            selectedEmployeeReportsTo: "",
            newCategory:"",
            newArea:"",
            // newDes is 0 and then you make it something else in Edit
            newDesignation: "",
            inList: false,
            // adderoniContext turns edit mode on
            // adderoniContext: null,
            categories: null
        }
    },
    created() {
        // When the site is created this happens
        //console.clear();
        //this.fetchVisits();
    },
    mounted() {
        console.log('component mounted');
        // Populating the arrays. Fetch data in mounted
        this.fetchCategories();
    },
    destroyed() {
        console.log('component destroyed');
    },
    // like the varialbes in name/data but a function
    // it is getting things from store, must compute
    // Store is the global variables and things
    computed: {
        dark() {
            return store.state.dark;
        },
        exporting() {
            return store.state.exporting;
        },
        exportComplete() {
            return store.state.exportComplete;
        },
        downloadURL() {
            return store.state.downloadURL;
        }
    },
    // all the js methods we are using and fb stuff
    methods: {
        // async is going to the store with the ingredigents
        // it is saying "keep going, i'll be back" to the other function
        async fetchVisits() {
            console.log('fetching current count.....');

            await firebase.firestore().collection('metrics').doc('fUWAPfClBOk27OfsjO9Q').get().then((doc) => {
                console.log('doc: ', doc.data())

                this.currentCount = doc.data().kmVisits;

                console.log('currentCount: ', this.currentCount);

                this.updateVisits();
            });
        },
        async updateVisits() {
            console.log('updating count and posting');
            this.currentCount++;

            await firebase.firestore().collection('metrics').doc('fUWAPfClBOk27OfsjO9Q').update({
                kmVisits: this.currentCount
            });

            console.log('newCount: ', this.currentCount);
        },
        
        wipe(wipeContext) {
            // Wipe list before reRendering the list
            var self = this;

            //console.clear();
            //console.log();
            //console.log("wiping...");
            //console.log();

            let items = document.querySelectorAll(wipeContext);

            console.log('ITEM RENDERED: ');

            items.forEach((item) => {
                //console.log(item);
                //console.log('ARE YOU DARK?:', self.dark);
                
                item.style.backgroundColor = 'transparent';
                item.style.color = ( self.dark ? 'white' : 'black' );
            });
        },
        handleCategoryClick(e) {

            //unhighlight everything else on click
            this.wipe('.wipe');

            console.log('TARGET: ', e.target);

            //highlight on click
            e.target.style.backgroundColor = 'black';
            e.target.style.color = 'white';

            this.categoryContext = e.target.innerHTML.replace("&amp;", "&");

            console.log(this.categoryContext);

            // this.showSubcategories = false;
            this.showEmployees = false;
            this.showAreas = true;

            console.log('hiding employees');
            console.log('hiding areas');
            // console.log('hiding subcategories');

            var self = this;
            // in vue, something you change this to self because it get's confused
            // on what exactly 'this' is.

            firebase
            .firestore()
            .collection("ms_skills_library")
            .where("category", "==", e.target.innerHTML.replace("&amp;", "&"))
            //.orderBy("area")
            .get().then(function(docs) {
                // get every area that has that category
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for parent category
                self.areas = [...new Set(rawDoc.map(x => x.area))];

                self.areas.sort();

                console.log('areas loaded: ', self.areas);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        // handleSubcategoryClick(e) {

        //     //unhighlight everything else on click
        //     this.wipe('.wipe2');

        //     e.target.style.backgroundColor = 'black';
        //     e.target.style.color = 'white';

        //     this.subcategoryContext = e.target.innerHTML.replace("&amp;", "&");

        //     console.log(this.subcategoryContext);

        //     this.showAreas = true;
        //     this.showEmployees = false;
        //     var self = this;
        //     firebase
        //     .firestore()
        //     .collection("skills_library")
        //     .where("subcategory", "==", e.target.innerHTML.replace("&amp;", "&"))
        //     //.orderBy("area", "desc")
        //     .get().then(function(docs) {
        //         let rawDoc = [];
        //         docs.forEach(doc => {
        //             rawDoc.push(doc.data());
        //         })
        //         //unique subcategories for parent category
        //         self.areas = [...new Set(rawDoc.map(x => x.area))];
        //         //console.log(self.areas);
        //     }).catch(function(error) {
        //         console.log('Error getting documents: ', error);
        //     });
        // },
        handleAreaClick(e) {
            //unhighlight everything else on click
            
            console.clear();

            console.log('event: ', e);


            console.log('handling area click');

            this.wipe('.wipe');

            e.target.style.backgroundColor = 'black';
            e.target.style.color = 'white';

            this.areaContext = e.target.innerHTML.replace("&amp;", "&");

            console.log(this.areaContext);

            this.currentUser = firebase.auth().currentUser.displayName;
            this.currentEmail = firebase.auth().currentUser.email;

            //console.clear();

            console.log('current user: ', this.currentUser);

            this.showEmployees = true;

            var self = this;

            self.employees = [];

            firebase
            .firestore()
            .collection("ms_skills_library")
            .where('category', '==', self.categoryContext)
            .where("area", "==", e.target.innerHTML.replace("&amp;", "&"))
            //.orderBy("employee", "desc")
            .get().then(function(docs) {

                let rawDoc = [];

                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })

                //unique subcategories for parent category

                let filtered = rawDoc;

                //updating sorted array

                filtered.forEach((employee) => {
                    //The if case is just to make sure the pulled data has an employee attached with it
                    if(employee.employee != undefined){
                        self.employees.push(employee);
                    }
                });

                self.employees.sort();

                //removing duplicates

                self.filterEmployees();
                console.log(self.employees);

                //checking if current user is in the list

                self.inList = false;

                self.employees.forEach((employee) => {
                    // console.log(employee.employee);

                    if(employee.employee == self.currentUser) {
                        self.inList = true;
                    }

                });
                
                //console.log(self.designation);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        handleEmployeeClick(item) {
            this.selectedEmployeeName = item.employee;
            this.selectedEmployeeEmail = item.email;
            this.selectedEmployeeReportsTo = item.reportsTo;
            this.userModal = true;
            console.log("User modal active");
        },
        styleRank(target) {
            if(target == 1) {
                return 'rank1';
            }
            else if(target == 2) {
                return 'rank2';
            }
            else { //target == 3
                return 'rank3';
            }
        },
        filterEmployees() {
            var self = this;
            const na = self.employees;

            //console.clear();
            //console.log('new employees array: ', na);

            var sorted = [];
            var trash = [];
        
            na.forEach((item) => {
                if(!trash.includes(item.employee)) {
                    sorted.push(item);
                    trash.push(item.employee);
                }
            });

            self.employees = sorted;
            console.log('employees filtered... ', self.employees);
        },
        handleCategoryAdd(){
            var self = this;
            
            var tempCategory = self.newCategory;
            tempCategory = tempCategory.toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');

            console.log(tempCategory);
            //quick function to ensure words are capitalized at start "Like This"
            var tempArea = self.newArea;
            tempArea = tempArea.toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');

            if(confirm("Are you sure you wish to add "+ "'"+ this.newCategory + "'"+ " as a category?")) {
                firebase
                .firestore()
                .collection('ms_skills_library')
                .doc().set({
                    category:tempCategory,
                    area:tempArea
                }).then(() => {
                    window.location.reload();
                    alert('Added ' + this.newCategory + " to the list.");
                });
            } else {
                alert('Operation canceled');
            }

            console.clear();
            console.log('adding new category....');


        },
        handleAreaAdd(){
            var self = this;
            var tempArea = self.newArea;
            tempArea = tempArea.toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');
            if(confirm("Are you sure you wish to add "+ "'"+ this.newArea + "'"+ " as a subcategory?")) {
                firebase
                .firestore()
                .collection('ms_skills_library')
                .doc().set({
                    category:self.categoryContext,
                    area: tempArea,
                }).then(() => {
                    window.location.reload();
                    alert('Added ' + this.newArea + " to the list.");
                });
            } else {
                alert('Operation canceled');
            }

            console.clear();
            console.log('adding new area....');


        },
        handleDesignationAdd() {
            var self = this;

            if(confirm('Add ' + this.currentUser + ' to ' + this.areaContext + '?')) {
                firebase
                .firestore()
                .collection('ms_skills_library')
                .doc().set({
                    area: self.areaContext,
                    category: self.categoryContext,
                    employee: self.currentUser,
                    email: self.currentEmail,
                    reportsTo: self.newDesignation
                }).then(() => {
                    self.addDesig = false;
                    self.newDesignation = "";
                    self.reloadEmployees();
                    alert('Added ' + this.currentUser + ' <' + this.currentEmail + '>' + ' to ' + this.areaContext + '.');
                });
            } else {
                alert('Operation canceled');
            }

            console.clear();
            console.log('adding new designation....');
        },
        async handleDelete() {
            var self = this;

            console.log('handling designation DELETE.......');

            var docCheck = null;

            if(confirm('Are you sure you want to delete your designation for ' + this.categoryContext + '?')) {
                await firebase
                .firestore()
                .collection('ms_skills_library')
                .where('category', '==', this.categoryContext)
                .where('area', '==', this.areaContext)
                .where('employee', '==', this.currentUser)
                .get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        doc.ref.delete().then(() => {
                            console.log('deleted ', doc.data());

                            //unhighlight everything else on click
                            
                            console.clear();

                            console.log('handling area click');

                            this.wipe('.wipe');

                            console.log(this.areaContext);

                            this.currentUser = firebase.auth().currentUser.displayName;
                            this.currentEmail = firebase.auth().currentUser.email;

                            //console.clear();

                            console.log('current user: ', this.currentUser);

                            this.showEmployees = true;

                            self.employees = [];

                            firebase
                            .firestore()
                            .collection("ms_skills_library")
                            .where('category', '==', self.categoryContext)
                            .where("area", "==", self.areaContext)
                            //.orderBy("employee", "desc")
                            .get().then((docs) => {

                                let rawDoc = [];

                                docs.forEach(doc => {
                                    rawDoc.push(doc.data());
                                })

                                //unique subcategories for parent category

                                let filtered = rawDoc;

                                //updating sorted array

                                filtered.forEach((employee) => {
                                    self.employees.push(employee);
                                });

                                self.employees.sort();

                                //removing duplicates

                                self.filterEmployees();
                                console.log(self.employees);

                                //checking if current user is in the list

                                self.inList = false;

                                self.employees.forEach((employee) => {
                                    console.log(employee.employee);

                                    if(employee.employee == self.currentUser) {
                                        self.inList = true;
                                    }

                                });
                                
                                //console.log(self.designation);
                            }).catch(function(error) {
                                console.log('Error getting documents: ', error);
                            });
                        });
                        docCheck = doc.data();
                    })
                });
                console.log('for science: ', docCheck);
            } else {
                alert('Operation canceled');
            }
        },
        //Also used to close other modals
        handleDesignationCancel() {
            this.showModal = false;
            this.areaModal = false;
            //this.newDesignation = 0;
            //console.log('attempted dessie ', this.newDesignation);
            console.log('handling designation cancel');
            console.log('modal visible? ', this.showModal);
        },
        handleEdit() {
            this.adderoniContext = 'edit';
            this.showModal = true;
            console.log(this.adderoniContext);
        },
        handleAdd() {
            //console.log('opening modal......');
            this.adderoniContext = 'add';
            this.showModal = true;
            //console.log(this.adderoniContext);

            //if(confirm('Add ' + this.currentUser + ' to "' + this.areaContext + '"?')) {
              //  console.log('handling add');
                //firebase.firestore().collection('skills_library').where('')
            //}
        },
        handleAddArea() {
            //console.log('opening modal......');
            this.adderoniContext = 'add';
            this.areaModal = true;
            console.log("Opening area modal");
            //console.log(this.adderoniContext);

            //if(confirm('Add ' + this.currentUser + ' to "' + this.areaContext + '"?')) {
              //  console.log('handling add');
                //firebase.firestore().collection('skills_library').where('')
            //}
        },
        reloadEmployees() {
            var self = this;
            
            console.log('reloading employees...');
 
            firebase
            .firestore()
            .collection("ms_skills_library")
            .where("category", "==", self.categoryContext)
            .where("area","==",self.areaContext)
            //.orderBy("designation", "desc")
            .get().then(function(docs) {
                let rawDoc = [];

                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })

                //unique subcategories for parent category

                let filtered = rawDoc;

                //updating sorted array

                filtered.forEach((employee) => {
                    if(employee.employee != undefined){
                        self.employees.push(employee);
                    }
                });

                self.employees.sort();

                //removing duplicates

                self.filterEmployees();
                console.log(self.employees);

                //checking if current user is in the list

                self.inList = false;

                self.employees.forEach((employee) => {
                    console.log(employee.employee);

                    if(employee.employee == self.currentUser) {
                        self.inList = true;
                    }

                });
                
                //console.log(self.designation);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        async fetchCategories() {
            var self = this;

            await
            firebase
            .firestore()
            .collection('ms_skills_library')
            .orderBy("category")
            .get().then(function(docs) {
                console.clear();
                console.log("done loading");
                self.doneLoading = true;
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for p]arent category
                self.categories = [...new Set(rawDoc.map(x => x.category))];
                //console.log('categories array: ', self.categories);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        handleAddDesig(){
            this.adderoniContext = "add";
            this.addDesig = true;
        },
        handleCancelDesig(){
            this.addDesig = false;
            this.newDesignation = "";
        }
        /*exportDB() {
            var jsonOutput = [];
            console.log('exporting database...');
            firebase.firestore().collection('skills_library').get().then((docs) => {
                docs.forEach((doc) => {
                    jsonOutput.push(doc.data());
                });
                jsonOutput = JSON.stringify(jsonOutput);
                console.log(jsonOutput);

            });
        }*/
    }
}
</script>

<template>
    <transition name="fade" mode="out-in">

        <div class="page-container" :class="(dark ? 'dark' : '' )">
           <!-- Modal for adding a category -->
            <transition name="fade" appear>
            <div class="modal-overlay" v-if="showModal" @click="showModal = false"></div>
        </transition>
        <transition name="fade">
            <div class="modal-content" v-if="showModal">
                <div class="category-title">Add a Category</div>
                <input v-model="newCategory" type="text" placeholder="Enter a new category" />
                <div class="category-title">Add a Subcategory</div>
                <input v-model="newArea" type="text" placeholder="Enter a new subcategory" />

                <div class="designation-buttons">
                    <div 
                    v-if="adderoniContext == 'add'"
                    :class="( newCategory.length > 0 && newArea.length > 0 ? 'clickable' : 'not-clickable' )" 
                    class="designation-button submit-button"
                    @click="handleCategoryAdd" 
                    >Add</div>
                    <div @click="handleDesignationCancel" class="designation-button cancel-button">Cancel</div>
                </div>
            </div>
        </transition>
        <!-- Modal for area adding --> 
        <transition name="fade" appear>
            <div class="modal-overlay" v-if="areaModal" @click="areaModal = false"></div>
        </transition>
        <transition name="fade">
            <div class="modal-content" v-if="areaModal">
                <div class="category-title">Add a Subcategory</div>
                <input v-model="newArea" type="text" placeholder="Enter a new subcategory" />
                <div class="designation-buttons">
                    <div 
                    v-if="adderoniContext == 'add'"
                    :class="( newArea.length > 0 ? 'clickable' : 'not-clickable' )" 
                    class="designation-button submit-button"
                    @click="handleAreaAdd" 
                    >Add</div>
                    <div @click="handleDesignationCancel" class="designation-button cancel-button">Cancel</div>
                </div>
            </div>
        </transition>
        <!--Designation adding modal -->
        <transition name="fade" appear>
            <div class="modal-overlay" v-if="areaModal" @click="areaModal = false"></div>
        </transition>
        <transition name="fade">
            <div class="modal-content" v-if="areaModal">
                <div class="category-title">Add a Subcategory</div>
                <input v-model="newArea" type="text" placeholder="Enter a new subcategory" />
                <div class="designation-buttons">
                    <div 
                    v-if="adderoniContext == 'add'"
                    :class="( newArea.length > 0 ? 'clickable' : 'not-clickable' )" 
                    class="designation-button submit-button"
                    @click="handleAreaAdd" 
                    >Add</div>
                    <div @click="handleDesignationCancel" class="designation-button cancel-button">Cancel</div>
                </div>
            </div>
        </transition>
        <!-- User modal when clicking on the name-->
        <transition name="fade" appear>
            <div class="modal-overlay" v-if="userModal" @click="userModal = false"></div>

        </transition>
        <transition name="fade">
            <div class="modal-content" v-if="userModal">
                <div class="modal-actionbar">
                    <div @click="() => { userModal = false; }" class="modal-exit" >x</div>
                </div>
                <div class="contact-image"></div>
                <h2 class="contact-name">{{ selectedEmployeeName }}</h2>
                <h3>{{selectedEmployeeEmail}}</h3>
                <h3><strong>Reports To: </strong>{{selectedEmployeeReportsTo}}</h3>
                <div class="contact-buttons">
                        <a :href="`mailto:` + selectedEmployeeEmail">
                            <div class="email-button contact-button">
                                <div class="email-icon contact-icon"></div>
                            </div>
                        </a>
                </div>
            </div>
        </transition>

            <div @click="() => { modalActive = false; }" class="page-container-inner" :class="( modalActive ? 'blur' : '' )">
                <div class="cards-container">
                    <!-- This is how the card streches and shit -->
                    <div class="categories-container">
                    <ul class="categories l1">
                        <div v-if="!doneLoading" class="loader">Loading...</div>
                        <!-- only render if doneLoading is true, when async is done  -->
                        <li v-for="(i, index) in categories" :key="index" ><p class="wipe wipe1 category" @click="handleCategoryClick">{{i}}</p></li>
                    
                    </ul>
                    
                    <div  class="add-catOrSub">
                            <div  @click="handleAdd" class="designation-option designation-add">Add Category</div>
                            
                    </div>
                    
                    </div>
                     <!-- this shows the subcats when clicked 
                            tbh we don't need the bottom part because
                            SkillDB does not have subcategories
                     -->

                    <!-- <span class="point" v-if="showSubcategories">🡒</span>

                    <ul v-if="showSubcategories" class="subcategories km-list">
                        <p class="no-results" v-if="subcategories.length == 0">No results</p>
                        <li v-for="item in subcategories" :key="item.index">
                            <p class="wipe wipe2" @click="handleSubcategoryClick">{{ item }}</p>
                        </li>
                    </ul> -->
                   

                    <span class="point" v-if="showAreas">🡒</span>
                    <div class="areas-container" v-if="showAreas">
                    <ul v-if="showAreas" class="areas km-list km-list-bigger">
                            <li v-for="item in areas" :key="item.index">
                                <p class="wipe wipe3" @click="handleAreaClick">{{ item }}</p>
                            </li>
                    </ul>
                    <div  class="add-catOrSub">
                            <div  @click="handleAddArea" class="designation-option designation-add">Add Subcategory</div>
                            
                    </div>
                    </div>
                    <span class="point" v-if="showEmployees">🡒</span>

                    <div class="employees-container">
                        <ul v-if="showEmployees" class="employees km-list">
                            <li class="final-items-container" v-for="item in employees" :key="item.index">
                                <p class="final-items" >
                                    <span :class="( item.employee == currentUser ? 'me' : '' )" class="employee-name" @click="handleEmployeeClick(item)">{{ item.employee }}</span>
                                </p>
                            </li>
                        </ul>
                        <div v-if="showEmployees" class="designation-options">
                            <div v-if="!inList" @click="handleAddDesig" class="designation-option designation-add">Add Designation</div>
                            <!--div v-if="inList" @click="handleEdit" class="designation-option designation-edit">Edit</div-->
                            <div v-if="inList" @click="handleDelete" class="designation-option designation-delete">Delete Designation</div>
                        </div>
                            <!-- add and delete designation 
                                if designation-edit is undone and
                                the bottom stuff then youll be able
                                to add the numbers for scale-->
                    </div>
                    <div v-if="addDesig" class="desig-modal">
                        <h3 class="currentUserName">{{ currentUser }}</h3>
                        <input v-model="newDesignation" type="text" placeholder="Supervisor's Email" />
                        <div class="designation-buttons">
                            <div 
                            v-if="adderoniContext == 'add'"
                            :class="( newDesignation.length > 0 ? 'clickable' : 'not-clickable' )" 
                            class="designation-button submit-button"
                            @click="handleDesignationAdd" 
                            >Add</div>
                            
                            <div @click="handleCancelDesig" class="designation-button cancel-button">Cancel</div>
                        </div>
            </div>
                    
                    
                    
                </div>

                <div class="wd">
                    <h4 class="directory">
                        <span>Categories</span>
                        <!-- <span v-if="showSubcategories"> / Subcategories</span> -->
                        <span v-if="showAreas"> / Area</span>
                        <span v-if="showEmployees"> / Employees</span>
                    </h4>
                    <div @click="exportDB('ms_skills_library')" class="export-button">Export Database</div>
                </div>
            </div>

            <div v-if="exporting" class="export-indicator" :style="'background-color: ' + ( exportComplete ? '#58A16D' : 'black' )">
                <strong>{{( !exporting ? '' : ( exportComplete ? 'Export Complete ✓' : 'Exporting Database...' ) )}}</strong>
                <a :href="downloadURL">
                    <div v-if="exportComplete" class="download-export">Download</div>
                </a>
            </div>
            <!-- This is how you export database -->
        </div>
    </transition>
</template>

<style scoped lang="scss">
@import '../assets/global-styles/variables';

.me {
    font-weight: bold !important;
    font-style: italic !important;
    opacity: 1 !important;
}

.designation-add {
    background: $colorGreen;
}

.designation-edit {
    background: $colorGreen;
}

.designation-delete {
    background: $colorRed;
}

.designation-option {
    border-radius: 18px;
    text-align: center;
    width: 100%;
    transition: 300ms;
    cursor: pointer;
    line-height: 36px;
    margin: 4px 6px 4px 6px;

    &:hover {
        opacity: 0.4;
    }
}
.modal-overlay{
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:98;
    background-color: rgba(0,0,0,0.3);
}

.modal-content{

    position: fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    z-index: 99;
    width: 100%;
    max-width: 400px;
    background-color: white;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

   /* 
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //height: calc(100% - 36px);
    margin-top: -140px; */
}
.category-title{
    margin-top:10px;
    margin-bottom:5px;
}
.designation-options {
    background: green;
    height: 40px;
    margin: 0px;
    border-radius: 0px 0px 18px 18px;
    text-align: center;
    color: white;
    display: flex;
    padding: 6px;
}

.designation-options {
    display: flex;
    background: $colorDarkMid;
}

.add-catOrSub{
    
    height: 40px;
    margin: 0px;
    border-radius: 0px 0px 18px 18px;
    text-align: center;
    color: white;
    display: flex;
    padding: 6px;
}
.add-catOrSubButton

.option-button {
    background: green;
    color: white;
    cursor: pointer;
    transition: 300ms;
    line-height: 40px;
    height: 40px;
    font-weight: bold;
    text-align: center;
    position: fixed;

    &:hover {
        opacity: 0.4;
    }

}

.clickable {
    opacity: 1;
    filter: contrast(1);
    pointer-events: all;
    cursor: pointer;
}

.not-clickable {
    opacity: 0.6;
    filter: contrast(0.2);
    pointer-events: none;
    cursor: default;
}

.currentUserName {
    font-size: 26px;
    margin-bottom: 32px;
}

.designation-modal {
    background: black;
    //position: relative;
    margin: 0px;
    height: 500px;
    width: 460px;
    margin-left: -280px;
    border-radius: 18px;
    animation: flyin forwards ease 300ms;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.desig-modal {
    background: black;
    position: relative;
    margin: 0px;
    height: 380px;
    width: 280px;
    margin-left: -280px;
    border-radius: 18px;
    animation: flyin forwards ease 300ms;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.designation-buttons {
    //background: purple;
    width: 100%;
    //height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;
    margin-top: 24px;
}

.designation-button {
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 18px;
    background: gray;
    font-weight: bold;
    cursor: pointer;
    transition: 300ms;
    color: white;
    padding: 4px 24px 4px 24px;
    margin-left: 6px;
    margin-right: 6px;
    margin-bottom:10px;

    &:hover {
        opacity: 0.4;
    }
}

.submit-button {
    background: $colorGreen;
}

.cancel-button {
    background: $colorDarkMid;
}

.designation-input {
    padding: 30px 0px 30px 16px;
    border-radius: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    border: none;
    height: 100px;
    width: 60px;
}

.directory {
    text-align: center;
}

.no-results {
    margin: 24px;
}

.employee-name {
    margin-right: 0px;
    opacity: 0.8;
}

.final-items-container {
    display: flex;
    margin-right: 0px;
    padding-right: 0px;
}

.designation {
    //background: red;
    margin: 0px;
    padding: 2px 8px 2px 8px;
    border-radius: 24px;
    line-height: 24px;
}
input {
  border:0;
  border-radius:25px;
  padding: 10px;
  box-shadow:1px 1px 1px 0px rgba(0,0,0,0.3);
  outline: 0;
  background: rgba(0,0,0,0.05);
  //border-bottom: 1px solid black;
}
.desig-modal input{

  border:0;
  border-radius:25px;
  width:75%;
  padding: 12px;
  box-shadow:1px 1px 1px 0px rgba(255,255,255,0.3);
  outline: 0;
  background: rgba(255,255,255,.8);
  //border-bottom: 1px solid black;

}

.rank1 {
    background: $colorBlue;
    opacity: 0.6;
}

.rank2 {
    background: $colorBlue;
}

.rank3 {
    background: $colorGreen;
}

.contact-name {
    margin-top: 24px !important;
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 0px !important;
}

h3 {
    font-weight: normal;
}

.email-icon {
    background-image: url('../assets/icons/mail-24px.svg');
}

.in-icon {
    background-image: url('../assets/icons/in.png');
}

.chat-icon {
    background-image: url('../assets/icons/chat.jpg');
}

.other-icon {
    background-image: url('../assets/icons/users.svg');
}

.modal-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //height: calc(100% - 36px);
    margin-top: -140px;
}

.modal-actionbar {
    //background: red;
    display:flex;
    justify-content: flex-end;
    padding: $gap;
    padding-bottom: 0px;
}

.modal-exit {
    border-radius: 100%;
    cursor: pointer;
    padding: 0px 12px 4px 12px;
    //font-weight: bold;
    font-size: 24px;

    //float: right;
    &:hover {
        background: #e0e0e0 !important;
    }
}

.contact-image {
    background-image: url('../assets/icons/profile-blank.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 100%;
    height: 124px;
    width: 124px;
    margin-bottom: 18px;
    //box-shadow: $softerShadow;
    //margin-top: -36px;
}

.email-button {
    background: $colorLightBlue !important;
    color: white;
}

.in-button {
    background: $colorBlue !important;
    color: white;
}

.chat-button {
    background: $colorGreen !important;
    color: white;
}

.contact-buttons {
    margin-left: auto;
    margin-right: auto;
    margin-top: $gap;
    cursor: pointer;
}

.contact-button {
    //background: yellow;
    display: block;
    margin-left: 12px;
    margin-right: 12px;
    //margin-top: $gap / 2;
    border-radius: 100%;
    transition: 200ms;
    padding: 6px 18px;
    margin-bottom: 18px;
    background: rgba(0,0,0,0.05);

    span {
        margin-left: 18px;
        margin-right: 18px;
        font-size: 14px;
        margin-bottom: 18px;
    }

    &:hover {
        transform: scale(1.1);
        box-shadow: $softerShadow;
    }

    .contact-icon {
        //background: black;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 30px;
        width: 30px;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: auto;
        margin-right: auto;
        opacity: 1;
        filter:invert(1);
    }
}

.contact-buttons {
    display: flex;
}

.blur {
    opacity: 0.2;
    filter: blur(64px) brightness(0.5);
    pointer-events: none;
}

.profile-modal-active {
    background: white;
    /*display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;*/
    position: absolute;
    z-index: 9999;
    transition: 600ms;
    opacity: 1;
    width: 800px;
    height: 390px;
    top: 80px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-radius: $rad;
    margin: auto;
    box-shadow: $softerShadow;
}

.profile-modal-inactive {
    //background: blue;
    /*display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;*/
    position: absolute;
    z-index: 9999;
    transition: 600ms;
    opacity: 0;
    width: 800px;
    height: 390px;
    top: 80px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-radius: $rad;
    transform: scale(0.8);
    pointer-events: none;
    margin: auto;
}

.final-items {
    &:hover {
        background: gray !important;
        color: white !important;
    }
}

.point {
    font-size: 24px;
    animation: flyin forwards ease 1s;
}

.dark {
    .page-container-inner {
        background: $colorDarkMid !important;
    }

    .modal-exit {
        &:hover {
            background: $colorDarkLight !important;
        }
    }

    .contact-icon {
        //filter: invert(1) !important;
    }

    .profile-modal-active {
        background: $colorDarkLight !important;
        color: white !important;
    }

    .km-list {
        background: $colorDarkLight !important;
        color: white !important;
        padding-bottom: 24px;
    }

    .li {
        background: $colorDarkLight !important;
        p {
            &:hover {
                background: $colorDarkMid !important;
            }
        }
    }

    .employees {
        background: white !important;
        margin-bottom: 0px !important;
        border-radius: 18px 18px 0px 0px !important;
        margin-top: 6px;
        height: 420px !important;
        
        li {
            p {
                color: black !important;
            }
        }
    }
}

.page-container {
    background: $colorBackdrop;
    flex-direction: column;
}

.page-container-inner {
    background: $colorBackdrop;
    flex-direction: column;
    transition: 400ms;
}

.cards-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wd {
    margin-top: 64px;
    text-align: center;

    span {
        //animation: flyup ease forwards 1s;
        margin: 0px;
    }
}

ul {
    list-style: none;
    padding-left: 24px;
    padding-bottom: 24px;
}

li {
    cursor: pointer;
    margin-top: 24px;

    p {
        width: max-content;
        padding: 3px 12px;
        border-radius: 48px;
        
        &:hover {
            background: #e0e0e0 !important;
            color: black !important;
        }   
    }
}

.employees {
    background: black !important;
    color: white;
    margin-bottom: 0px !important;
    border-radius: 18px 18px 0px 0px !important;
    margin-top: -6px;
    height: 420px !important;

    p {
        &:hover {
            background: transparent !important;
        }
    }
}

span {
    margin-left: 24px;
    margin-right: 24px;
}

.l1 {
    background: white;
    height: 500px;
    width: 460px;
    overflow:auto;
    border-radius: $rad; 
}

.km-list {
    background: white;
    height: 500px;
    width: 460px;
    overflow:auto;
    border-radius: $rad;
    animation: expand forwards ease 1s;
    //box-shadow: $softerShadow;
}

.km-list-big {
    width: 530px;
    animation: expand2 forwards ease 1s;
}

.km-list-bigger {
    width: 535px;
    animation: expand2 forwards ease 1s;
}

::-webkit-scrollbar {
  width: 32px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border: none;
}

::-webkit-scrollbar-thumb {
  border: 12px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 24px;
  background-color: #eeeeee;
  //-webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}

.dark-mode::-webkit-scrollbar-thumb {
  background: gray !important;
  border-radius: 24px;
}

p {
    margin: 0px;
}

.loader {
  margin: auto;
  font-size: 25px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: absolute;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  filter: invert(1);
  transform: scale(0.2);
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: -245px;
}
// This is a safety net for different browser Some of them arnt as cool as others
@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #ffffff, 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.5), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.7), 1.8em -1.8em 0 0em #ffffff, 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.5), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7), 2.5em 0em 0 0em #ffffff, 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5), 2.5em 0em 0 0em rgba(255, 255, 255, 0.7), 1.75em 1.75em 0 0em #ffffff, 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.5), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.7), 0em 2.5em 0 0em #ffffff, -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.5), 0em 2.5em 0 0em rgba(255, 255, 255, 0.7), -1.8em 1.8em 0 0em #ffffff, -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.5), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.7), -2.6em 0em 0 0em #ffffff, -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.5), -2.6em 0em 0 0em rgba(255, 255, 255, 0.7), -1.8em -1.8em 0 0em #ffffff;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #ffffff, 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.5), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.7), 1.8em -1.8em 0 0em #ffffff, 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.5), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7), 2.5em 0em 0 0em #ffffff, 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5), 2.5em 0em 0 0em rgba(255, 255, 255, 0.7), 1.75em 1.75em 0 0em #ffffff, 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.5), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.7), 0em 2.5em 0 0em #ffffff, -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2), -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.5), 0em 2.5em 0 0em rgba(255, 255, 255, 0.7), -1.8em 1.8em 0 0em #ffffff, -2.6em 0em 0 0em rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.5), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.7), -2.6em 0em 0 0em #ffffff, -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2), 2.5em 0em 0 0em rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2), 0em 2.5em 0 0em rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.5), -2.6em 0em 0 0em rgba(255, 255, 255, 0.7), -1.8em -1.8em 0 0em #ffffff;
  }
}


</style>